// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        size: 'small',
        color: 'secondary',
      },
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
          overflowWrap: 'anywhere',
        },
        sizeLarge: {
          height: 48,
        },
        sizeSmall: {
          paddingTop: '7.43px',
          paddingBottom: '7.43px',
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          // boxShadow: theme.customShadows.z8,
          // '&:hover': {
          //   backgroundColor: theme.palette.grey[400],
          // },
        },
        text: {
          color:
            theme.palette.mode === 'light'
              ? theme.palette.primary.main
              : theme.palette.primary.contrastText,
        },
        containedPrimary: {
          // boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          // boxShadow: theme.customShadows.secondary,
        },
        containedInfo: {
          // boxShadow: theme.customShadows.info,
        },
        containedSuccess: {
          // boxShadow: theme.customShadows.success,
        },
        containedWarning: {
          // boxShadow: theme.customShadows.warning,
        },
        containedError: {
          // boxShadow: theme.customShadows.error,
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
